
import ReactVisibilitySensor from 'react-visibility-sensor'
import MainHeaderPropsType from '../types/MainHeaderPropsType'
import { useContext } from 'react'
import { LangContext } from '../App'

const MainHeader = ({
    title,
    subtitle,
    image,
    imagePosition
} : MainHeaderPropsType) => {
    const { lang } = useContext(LangContext);
  return (
    <header className={`main-header ${lang ? "rtl" : ""}`} id={"header"}>
        <img src={image.src} alt={image.alt} className={`bg-image ${imagePosition === "left" ? "bg-image-left" : ""}`} />
        <div className="overlay">
            <div className="wrapper">
                <ReactVisibilitySensor
                    partialVisibility
                >
                {({isVisible} : any) => (
                    <div className={`content-box an-move-left-fade-in ${isVisible ? "an-active" : ""}`}>
                        {title ? <h1 className="title">{title}</h1> : ""}
                        {subtitle ? <p className="subtitle">{subtitle}</p> : ""}
                    </div>
                )}
                </ReactVisibilitySensor>
            </div>
        </div>
    </header>
  )
}

export default MainHeader